import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Drawer,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import CdmoWarning from "./CdmoWarning";
import axios from "axios";
import BrandWarning from "./BrandWarning";
import { appUrl } from "../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  textFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  content: {
    flexGrow: 1,
  },

  heading: {
    fontWeight: 600,
    marginBottom: "1em",
  },
  drawerPaper: {
    width: "30vw",
  },
  saveBtn: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
}));

// const fetchedData ={
//     "status": true,
//     "message": "All User Associations fetched successfully",
//     "data": {
//         "collaboratorRoleID": 27802,
//         "associatedBrandList": [  "Cipla",  "Baraclude" ],
//         "associatedCMOList": [ 3, 4 ],
//         "associatedProductTypesList": [ 1, 2 ],
//         "saasUserID": 16,
//         "status": true,
//         "statusCode": 200
//     }
// }

// const dummyAPI = [
//   { cdmo_name: "Oxford Biomedica", cdmo_id: "1" },
//   { cdmo_name: "Recipharm", cdmo_id: "2" },
//   { cdmo_name: "Catalent", cdmo_id: "3" },
//   { cdmo_name: "AGC Life Sciences", cdmo_id: "4" },
//   { cdmo_name: "Lonza", cdmo_id: "5" },
//   { cdmo_name: "Thermo Fisher", cdmo_id: "6" },
//   { cdmo_name: "WuXi Biologics", cdmo_id: "7" },
//   { cdmo_name: "Samsung Biologics", cdmo_id: "8" },
//   { cdmo_name: "Piramal Pharma", cdmo_id: "9" },
//   { cdmo_name: "Almac", cdmo_id: "10" },
//   { cdmo_name: "Patheon", cdmo_id: "11" },
//   { cdmo_name: "AMRI", cdmo_id: "12" },
//   { cdmo_name: "Baxter BioPharma", cdmo_id: "13" },
//   { cdmo_name: "Cambrex", cdmo_id: "14" },
//   { cdmo_name: "Vetter Pharma", cdmo_id: "15" },
//   { cdmo_name: "Ajinomoto Bio-Pharma", cdmo_id: "16" },
//   { cdmo_name: "Fujifilm Diosynth", cdmo_id: "17" },
//   { cdmo_name: "CordenPharma", cdmo_id: "18" },
//   { cdmo_name: "Evonik", cdmo_id: "19" },
//   { cdmo_name: "Hovione", cdmo_id: "20" },
//   { cdmo_name: "Biocon", cdmo_id: "21" },
//   { cdmo_name: "Strides Pharma", cdmo_id: "22" },
//   { cdmo_name: "Dishman Carbogen Amcis", cdmo_id: "23" },
//   { cdmo_name: "Siegfried", cdmo_id: "24" },
//   { cdmo_name: "Lupin", cdmo_id: "25" },
//   { cdmo_name: "Dr. Reddy's", cdmo_id: "26" },
//   { cdmo_name: "Mylan", cdmo_id: "27" },
//   { cdmo_name: "Aurobindo Pharma", cdmo_id: "28" },
//   { cdmo_name: "Sanofi", cdmo_id: "29" },
//   { cdmo_name: "GSK", cdmo_id: "30" },
//   { cdmo_name: "Pfizer", cdmo_id: "31" },
//   { cdmo_name: "Roche", cdmo_id: "32" },
//   { cdmo_name: "Bayer", cdmo_id: "33" },
//   { cdmo_name: "Novartis", cdmo_id: "34" },
//   { cdmo_name: "Merck", cdmo_id: "35" },
//   { cdmo_name: "Teva", cdmo_id: "36" },
//   { cdmo_name: "Celgene", cdmo_id: "37" },
//   { cdmo_name: "Shire", cdmo_id: "38" },
//   { cdmo_name: "Boehringer Ingelheim", cdmo_id: "39" },
//   { cdmo_name: "AstraZeneca", cdmo_id: "40" },
//   { cdmo_name: "Sponsor", cdmo_id: "41" },
//   { cdmo_name: "Vertex Pharmaceuticals", cdmo_id: "42" },
//   { cdmo_name: "Biogen", cdmo_id: "43" },
//   { cdmo_name: "Regeneron", cdmo_id: "44" },
//   { cdmo_name: "AbbVie", cdmo_id: "45" },
//   { cdmo_name: "Eli Lilly", cdmo_id: "46" },
//   { cdmo_name: "Novo Nordisk", cdmo_id: "47" },
//   { cdmo_name: "Ipsen", cdmo_id: "48" },
//   { cdmo_name: "Takeda", cdmo_id: "49" },
//   { cdmo_name: "UCB", cdmo_id: "50" },
//   { cdmo_name: "Endo International", cdmo_id: "51" },
//   { cdmo_name: "Sun Pharma", cdmo_id: "52" },
//   { cdmo_name: "Zydus Cadila", cdmo_id: "53" },
//   { cdmo_name: "Torrent Pharma", cdmo_id: "54" },
//   { cdmo_name: "Alembic", cdmo_id: "55" },
// ];

export default function AssociateBrands({
  user,
  setViewDetailsDrawer,
  ViewDetailsDrawer,
  handleRefresh,
  selectedRole,
}) {
  const classes = useStyles();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [cdmoAPI, setCdmoAPI] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedProductOptions, setSelectedProductOptions] = useState([]);
   const [productType, setProductType] = useState([]);
  const [fetchUserData, setFetchUserData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [discard, setDiscard] = useState(false); //toggle
  const [accessOption, setAccessOption] = useState(""); // Default to 'all' radio button
  const [associatedIds, setAssociatedIds] = useState(
    user?.associatedCDMOOrgIDs
  );
  const [brandDrawer, setBrandDrawer] = useState(false);
const [initialSelectedOptions, setInitialSelectedOptions] = useState([]);
const [initialSelectedProductOptions, setInitialSelectedProductOptions] = useState([]);

  const handleAccessChange = (event) => {
    const value = event.target.value;
    setAccessOption(value);
    if (value === "all") {
      setSelectedOptions(cdmoAPI);
      setAssociatedIds("all");
    } else{
      setSelectedOptions([]);
    }
  };

  useEffect(() => {
    if(accessOption === "all"){
   setSelectedOptions(cdmoAPI);
    }
  }, [accessOption,cdmoAPI]);
  //fetch all cdmos

  useEffect(() => {
    setLoading(true);
    // setAccessOption(user?.associatedCDMOOrgIDs === "all" ? "all" : "select");

    // const url =
    //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
       const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchUserAssociations/${user?.saas_user_id}`;

    axios
      .get(url)
      .then((res) => {
      if(res.data.status){
setFetchUserData(res.data)
// setFetchUserData(fetchedData);
      }
      })
      .catch((err) => {
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

useEffect(() => {
  setLoading(true);
    const url =  `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllBrands`;
if(fetchUserData?.data){
  axios
    .get(url)
    .then((res) => {
      if (res.data.status) {
        const allBrands = res?.data?.data?.Brands || [];
        setCdmoAPI(allBrands); // Set the full list to state

        // if (user?.associatedCDMOOrgIDs === "all") {
        //   setSelectedOptions([]);
        //   setAssociatedIds("all");
        // } else {
if(fetchUserData?.data?.associatedBrandList && cdmoAPI){
            const userBrands = fetchUserData?.data?.associatedBrandList || [];
          const normalizedAllBrands = allBrands.map(brand => brand.trim().toUpperCase());
          const matchedBrands = userBrands
            .map(userBrand => {
              const normalizedUserBrand = userBrand.trim().toUpperCase();
              const index = normalizedAllBrands.indexOf(normalizedUserBrand);
              return index !== -1 ? allBrands[index] : null;
            })
            .filter(brand => brand !== null);
          
          // Remove duplicates using Set
          const uniqueMatchedBrands = [...new Set(matchedBrands)];
          
          setSelectedOptions(uniqueMatchedBrands); 
          setInitialSelectedOptions(uniqueMatchedBrands);
          setAccessOption(uniqueMatchedBrands.length  === allBrands.length ? "all" : "select");
}
    
      } else {
        setCdmoAPI([]);
      }
    })
    .catch((err) => {
      setError(true);
    })
    .finally(() => setLoading(false));
  }
}, [fetchUserData,discard]);

    useEffect(() => {
    setLoading(true);

    // const url = `${appUrl}/user/fetchCdmoDetails`;
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/false`;
    // const url =
    //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
if(fetchUserData?.data){
      axios
      .get(url)
      .then((res) => {
            if (res.data.status && Array.isArray(res.data.data?.productTypeList)) {
      // setProductType(res.data.data.productTypeList);
      // setError(null);
              const fetchedProductTypes = res.data.data.productTypeList;
        setProductType(fetchedProductTypes);
        setError(null);

        // ✅ Match with user's associatedProductTypesList
        const userProductTypeIds =
          fetchUserData?.data?.associatedProductTypesList || [];

        const matchedProductTypes = fetchedProductTypes.filter((type) =>
          userProductTypeIds.includes(type.productTypeID)
        );

        setSelectedProductOptions(matchedProductTypes);
        setInitialSelectedProductOptions(matchedProductTypes); 
    } 
         else setProductType([]);
      })
      .catch((err) => {
        setError(err.message);
        })
      .finally(() => setLoading(false));
}
  }, [fetchUserData,discard]);

  const isEqualArray = (a, b) => {
  if (a.length !== b.length) return false;
  return a.every((itemA) =>
    b.some(
      (itemB) =>
        JSON.stringify(itemA) === JSON.stringify(itemB)
    )
  );
};

const isDifferent = (arr1, arr2) => {
  return arr1.length !== arr2.length || arr1.some((id) => !arr2.includes(id));
};

  const handleSave = () => {
    setBrandDrawer(true);

 const optionsChanged = isDifferent(selectedOptions, initialSelectedOptions);
  const productOptionsChanged = isDifferent(selectedProductOptions, initialSelectedProductOptions);
  if (optionsChanged || (optionsChanged && productOptionsChanged)) {
    setSuccessMessage("Associated Brands updated successfully");
  } else if (productOptionsChanged) {
    setSuccessMessage("Associated ProductTypes updated successfully");
  }
  };
  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center", // Horizontally center the CircularProgress
        alignItems: "center", // Vertically center the CircularProgress
        height: "50px", // Optional: Set a height to vertically center the loader
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "1.5em",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );
  if (loading) return displayLoading;
  if (error) return displayError;
//   if (cdmoAPI?.length === 0) return displayNoRecordsFound;
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Typography className={classes.heading}>Associate Brands</Typography>
      <FormControl style={{ width: "100%" }}>
        <RadioGroup value={accessOption} onChange={handleAccessChange}>
          <FormControlLabel
            value="all"
            control={<Radio color="primary" />}
            label={
              <span style={{ fontSize: "14px" }}>
                {`Access all Brands (${cdmoAPI.length})`}
              </span>
            }
          />
          <FormControlLabel
            value="select"
            control={<Radio color="primary" />}
            label={
              <span style={{ fontSize: "14px" }}>Access select Brands</span>
            }
          />
        </RadioGroup>
      </FormControl>
      <FormControl style={{ width: "100%", height: "100%" }}>
        {/* <Autocomplete
          multiple
          size="small"
          value={selectedOptions}
          options={cdmoAPI}
          getOptionLabel={(option) => option.cdmo_name}
          onChange={(event, value) => {
            setSelectedOptions(value);
            setAssociatedIds(value.map((option) => option.cdmo_id).join(","));
          }}
          disabled={accessOption === "all"}
          disableCloseOnSelect
          renderInput={(params) => (
            <TextField
              size="small"
              {...params}
              variant="outlined"
              placeholder="Start typing to search"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          )}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                checked={selected}
                style={{ marginRight: 8 }}
                color="primary"
              />
              {option.cdmo_name}
            </React.Fragment>
          )}
        /> */}

        <Autocomplete
  multiple
  size="small"
  value={selectedOptions} // array of strings
  options={cdmoAPI}       // array of strings like ["Cipla", "Baraclude"]
  getOptionLabel={(option) => option} // since option is just a string
  onChange={(event, value) => {
    setSelectedOptions(value); // value is an array of strings
    setAssociatedIds(value.join(",")); // if needed as comma-separated
  }}
  disabled={accessOption === "all"}
  disableCloseOnSelect
  renderInput={(params) => (
    <TextField
      size="small"
      {...params}
      variant="outlined"
      placeholder="Start typing to search"
      InputProps={{
        ...params.InputProps,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  )}
  renderOption={(option, { selected }) => (
   <React.Fragment>
      <Checkbox
        checked={selected}
        style={{ marginRight: 8 }}
        color="primary"
      />
      {option}
  </React.Fragment>
  )}
/>

      </FormControl>
      <FormControl
        style={{ marginTop: "1em", marginBottom: "1em", width: "100%" }}
      >
        <Typography variant="body1">Your selections</Typography>
        <TextField
          disabled
          size="small"
          minRows={4}
          fullWidth
          value={
            selectedOptions.map((option) => option).join(", ") || ""
          } // Display selected names
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
          multiline
          style={{ width: "100%" }}
        />
      </FormControl>

                <Typography
                  style={{ fontSize: "16px", fontWeight: 600 }}
                  gutterBottom
                >
                  Associate Product Types
                </Typography>
    
    
    <FormControl component="fieldset" style={{ width: "100%" }}>
        <FormGroup>
        {productType.map((item) => (
          <FormControlLabel
            key={item.productTypeID}
            control={
              <Checkbox
                checked={selectedProductOptions.some(
                  (selected) => selected.productTypeID === item.productTypeID
                )}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  let updatedSelection;
                  if (isChecked) {
                    updatedSelection = [...selectedProductOptions, item];
                  } else {
                    updatedSelection = selectedProductOptions.filter(
                      (pt) => pt.productTypeID !== item.productTypeID
                    );
                  }
                  setSelectedProductOptions(updatedSelection);
                  // Optional: setAssociatedIds(updatedSelection.map(i => i.productTypeID).join(","));
                }}
                color="primary"
              />
            }
            label={item.productTypeName}
          />
        ))}
      </FormGroup>
    </FormControl>  

      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            setDiscard((prev) => !prev);
          }}
          style={{ textTransform: "none" }}
        >
          Discard changes
        </Button>
        <Button
          size="small"
          variant="contained"
          className={classes.saveBtn}
          onClick={handleSave}
        //  disabled={selectedOptions.length === 0 || selectedProductOptions.length === 0}
        disabled={
  selectedOptions.length === 0 ||
  selectedProductOptions.length === 0 ||
  (
    isEqualArray(selectedOptions, initialSelectedOptions) &&
    isEqualArray(selectedProductOptions, initialSelectedProductOptions)
  )
}
        >
          Save changes
        </Button>
      </Box>
      <Drawer
        anchor="right"
        open={brandDrawer}
        onClose={() => setBrandDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <BrandWarning
          setBrandDrawer={setBrandDrawer}
          successMessage={successMessage}
          associatedIds={associatedIds}
          user={user}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
          selectedRole={selectedRole}
          selectedOptions={selectedOptions}
          selectedProductOptions={selectedProductOptions}
          originalBrands={initialSelectedOptions}
          originalProductTypes={initialSelectedProductOptions.map(item => item.productTypeID)}
        />
      </Drawer>
    </Box>
  );
}
